export default {
  title01: "Текущо време",
  title02: "24 часа",
  title03: "Виж 10-дневна прогноза за времето",
  title04: "AQI",
  title05: "Виж цялата информация",
  title06: "ИЗГРЕВ И ЗАЛЕЗ",
  title07: "ФАЗА НА ЛУНАТА",
  title08: "Следващото пълнолуние",
  title09: "Следващото новолуние",
  title10: "ДЕН",
  title11: "НОЩ",
  title12: "Изгрев",
  title13: "Залез",
  title14: "Лунен изгрев",
  title15: "Лунен залез",
  title16: "Източник",
  title17: "Начало",
  title18: "Край",
  title19: "Използвай текущото местоположение",
  title20: "Търсене на град",
  title21: "Усеща се като",
  title22: "Усеща се като в сянка",
  title23: "Сега",
  title24: "Днес",
  title25: "НЕД",
  title26: "ПОН",
  title27: "ВТ",
  title28: "СР",
  title29: "ЧЕТ",
  title30: "ПЕТ",
  title31: "СЪБ",
  title32: "Зареждане...",
  title33: "Сега",
  title34: "Почасово",
  title35: "Дневно",
  title36: "Слънце и Луна",
  title37: "Качество на въздуха",
  title38: "Контакт с: xlf550402@gmail.com",
  title39: "Политика за поверителност",
  title40: "Авторско право © comfortweather.com 2020 - 2024. Всички права запазени.",
  title41: "Данни предоставени от",
  title42: "Високо",
  title43: "Ниско",
  title44: "Приемам",
  title45:
    "Благодарим ви, че използвате ComfortWeather! За да защитим по-добре вашите законни права и интереси, моля, прочетете внимателно ",
  title46: "Политиката за поверителност",
  title47: " преди използване.",
  title48: "",
  title49: "Контакт с: xyjph123@gmail.com",
  title50: "Авторско право © 24hweather.com 2020 - 2024. Всички права запазени.",
  title51:
    "Благодарим ви, че използвате 24hweather! За да защитим по-добре вашите законни права и интереси, моля, прочетете внимателно ",
};
